import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "react-data-table-component-extensions/dist/index.css";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {  Apitoken, Authtoken } from "../Global";
import {MaterialReactTable} from 'material-react-table';
import Swal from 'sweetalert2';
import PropTypes from 'prop-types';

//Material UI Imports
import {
  MenuItem,
} from '@mui/material';
const Consumable = () => {
  const [menu, setMenu] = useState(false);
  const [data, setData] = useState([]);
  const [permission, setPermission] = useState({});

  useEffect(() => {
    setPermission(FindModuleById(121)); 

    axios.post("/consumables/listing",{},{  headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
      .then((response) => {
       
        if (response.data.code === 200) {
          setData(response.data.data.products);
        }
        else  if (response.data.code === 401) {
          window.location.href = "/login";
        }else{
          window.location.href = "/login"; 
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);


const editItem = (item)=>{
  window.location.href = "/consumables-edit/"+item;
}


  const deleteItem = (item) => {
    Swal.fire({
      title: 'Do you really want to delete this record?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'DELETE'
    }).then((result) => {
      if (result.isConfirmed) {
        axios.get(`/consumables/delete/${item}`, {
              headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
            })
            .then((response) => {
              console.log(response);
              if (response.data.code === 200) {
                Swal.fire(
                  'Deleted!',
                  'Your Record has been deleted.',
                  'success'
                );
                setTimeout(() => {
                  window.location.href = "/consumables";
                }, 500);
              }
            })
            .catch((error) => {
              console.log(error);
            });
      }
    });
  }

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };


// const columns =
//  [
  
//   {
//     header: 'Consumable Name',
//     //accessorFn: (row) => `${row.consumable_name}`,
//     Cell: ({ renderedCellValue, row }) => {        
   
//           return(
//             <a href={'/consumables-view/'+row.original.id} className=""  >
//                {row.original.consumable_name}
//             </a>
            
//           )
//     },

//   },
   
//     {
//       accessorKey: 'critical_level',
//       header: 'Critical level',
//     },
//     {
//       accessorKey: 'average_level',
//       header: 'Average level',
//     },
//     {
//       header: 'Pckaging',
//       accessorFn: (row) => `${(row.packaging == 1)?'YES':"NO"} `,
//     },
//     {
//       accessorKey: 'description', //normal accessorKey
//       header: 'Description',
//     },
//     {
//       header: 'Created By',
//       accessorFn: (row) => `${(row.createdby)?row.createdby.first_name+ ' '+ row.createdby.last_name:""} `,
//     },
//     {
//       header: 'Updated By',
//       accessorFn: (row) => `${(row.updatedby)?row.updatedby.first_name+ ' '+ row.updatedby.last_name:""} `,
//     },
//   ];


const ConsumableCell = ({ row }) => {
  console.log("Row Data:", row); // Debugging to check row structure

  const id = row?.original?.id || '';
  const name = row?.original?.consumable_name || 'N/A';

  return <a href={`/consumables-view/${id}`} className="">{name}</a>;
};

// ✅ Define PropTypes inside the function
ConsumableCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      consumable_name: PropTypes.string,
    }),
  }).isRequired,
};

const columns = [
  {
    header: 'Consumable Name',
    accessorKey: 'consumable_name', // Ensures this field is recognized
    Cell: ConsumableCell, // Use the separate component
  },
  {
    accessorKey: 'critical_level',
    header: 'Critical Level',
  },
  {
    accessorKey: 'average_level',
    header: 'Average Level',
  },
  {
    header: 'Packaging',
    accessorFn: (row) => (row.packaging == 1 ? 'YES' : 'NO'),
  },
  {
    accessorKey: 'description',
    header: 'Description',
  },
  {
    header: 'Created By',
    accessorFn: (row) =>
      row?.createdby ? `${row.createdby.first_name} ${row.createdby.last_name}` : '',
  },
  {
    header: 'Updated By',
    accessorFn: (row) =>
      row?.updatedby ? `${row.updatedby.first_name} ${row.updatedby.last_name}` : '',
  },
];
  return (
    <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
      <Header onMenuClick={() => toggleMobileMenu()} />
      <Sidebar />

      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">Consumables</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/profile">Profile</Link>
                  </li>
                  <li className="breadcrumb-item active">Consumables</li>
                </ul>
              </div>
              <div className="col-auto">
                {permission && permission.add === 1 && (
                    <Link to="/consumables-add" className="btn btn-primary me-1">
                    <i className="fas fa-plus"></i>
                  </Link>
                )} 
                
              </div>
            </div>
          </div>

          <div className="row">
            
            <div className="col-sm-12">
              <div className="card card-table">
                <div className="card-body">
                    {permission && permission.list === 1 && ( 
                      <div className="table-responsive">
                      <MaterialReactTable columns={columns} data={data} 
                        // enableColumnFilterModes
                        enableColumnOrdering
                        // enableGrouping
                        enablePinning
                        enableRowActions
                        // enableRowSelection
                        // initialState={{ showColumnFilters: true }}
                      
                       renderRowActionMenuItems={({ row }) => [
                          permission?.update === 1 && (
                            <MenuItem key="edit" onClick={() => editItem(row.original.id)}>
                              Edit
                            </MenuItem>
                          ),
                          permission?.delete === 1 && (
                            <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                              Delete
                            </MenuItem>
                          ),
                        ]}
                      />
                      </div>
                    
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Consumable;
